import { defineComponent } from 'vue';
export default defineComponent({
    name: 'gebrauchte-geraete-verkaufen',
    data() {
        return {
            checkpoints: [
                'Auszahlung innerhalb 24 Stunden',
                'Kostenloses Versandlabel ab 30 € Ankaufswert',
                'Kostenlose Abholung ab 100 € Ankaufswert',
                '900.000+ zufriedene Kunden',
            ],
        };
    },
});
